import React from 'react'
import xCircle from '../../../../media/svg/x-circle.svg'
import facebookCircle from '../../../../media/svg/facebook-circle.svg'
import youtubeCircle from '../../../../media/svg/youtube-circle.svg'
import instagramCircle from '../../../../media/svg/instagram-circle.svg'
import tiktokCircle from '../../../../media/svg/tiktok-circle.svg'
import threadCircle from '../../../../media/svg/thread-circle.svg'

const SocialMedia = () => {
    return (
        <div className="container-fluid" id="social-media">
            <div className="row justify-content-center">
                <div className="col-12 social-media-footer">
                    <div className="social-envelope">
                        <a href="">
                            <img src={xCircle} alt="X" className="icon-social" />
                            <p>TEPJF_informa</p>
                        </a>
                    </div>
                    <div className="social-envelope">
                        <a href="">
                            <img src={facebookCircle} alt="Facebook" className="icon-social" />
                            <p>TEPJF</p>
                        </a>
                    </div>
                    <div className="social-envelope">
                        <a href="">
                            <img src={youtubeCircle} alt="Youtube" className="icon-social" />
                            <p>TEPJF</p>
                        </a>
                    </div>
                    <div className="social-envelope">
                        <a href="">
                            <img src={instagramCircle} alt="Instagram" className="icon-social" />
                            <p>tepjf_salasuperior</p>
                        </a>
                    </div>
                    <div className="social-envelope">
                        <a href="">
                            <img src={tiktokCircle} alt="Tiktok" className="icon-social" />
                            <p>tepjf_informa</p>
                        </a>
                    </div>
                    <div className="social-envelope">
                        <a href="">
                            <img src={threadCircle} alt="Thread" className="icon-social" />
                            <p>tepjf_salasuperior</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default SocialMedia
